import React from "react";
import "./styles/HelpCenter.css";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const HelpCenter = () => {
    const navigate = useNavigate();

    return (
        <div className="help-page">

            <div className="help-container">
                <button
    className="help-back-btn"
    onClick={() => navigate("/")}
>
    ← Back to Home
</button>

                <div className="help-hero">
                    <p className="help-tag">SUPPORT CENTER</p>

                    <h1>Help Center</h1>

                    <p>
                        Get assistance with Genesis HRMS features, account setup,
                        payroll operations, attendance management, and platform support.
                    </p>
                </div>

                <div className="help-grid">

                    <div className="help-card">
                        <h3>Attendance Management</h3>
                        <p>
                            Learn how to manage attendance records, shifts,
                            biometric integrations, and reports.
                        </p>
                    </div>

                    <div className="help-card">
                        <h3>Performance Management</h3>
                        <p>
                            Get guidance on goal tracking,
                            performance reviews, OKRs,
                            and employee development plans.
                        </p>
                    </div>

                    <div className="help-card">
                        <h3>Employee Management</h3>
                        <p>
                            Guidance on employee profiles,
                            leave requests, approvals, and workflows.
                        </p>
                    </div>

                </div>

                <div className="help-contact">

                    <h2>Need Additional Help?</h2>

                    <p>Email: contact@genesistech.co.in</p>

                    <p>Phone: +91 7841063605</p>

                    <p>
                        Our support team is available to assist your organization.
                    </p>

                </div>

            </div>

            <Footer />

        </div>
    );
};

export default HelpCenter;